<template>
  <!-- 编辑关联设备 -->
  <modal :visible.sync="visible" :title="title" width="1200px" top="20px" append-to-body>
    <div class="uk-flex h-100" :class="{ 'wrpper-h': !single }">
      <!-- 左侧映射列表 -->
      <div class="border  border-box reflect-box uk-flex uk-flex-column" v-if="!single">
        <div class="pd-5 bd-b">
          <el-input v-model="model.searchName" @change="searchNameChange" :placeholder="$t('integration.installation_point')"></el-input>
        </div>
        <div class="uk-flex-1" style='overflow-y: auto;'>
          <div class="uk-flex border uk-text-center reflect-item "  v-for="(probe, index) in probeList"
               :key="probe.id">
            <div class="uk-flex-1 cursor-pointer ellipsis" :class="{ active: currentProbe.id === probe.id }"
                 :title="probe.name"
                 @click="changeProbe(probe)">{{ probe.name }}</div>
            <div class="bd-l" style="width: 30px;">
              <i class="el-icon-delete cursor-pointer" @click="deleteProbe(probe, index)"></i>
            </div>
          </div>
        </div>
        <div class="bd-t uk-text-center bottom-area hover-active" @click="addProbe">
          <i class="el-icon-plus font-16 cursor-pointer"></i>
        </div>
      </div>

      <!-- 右侧操作列表 -->
      <div class="uk-flex-1 border-box bd-r bd-t h-100" :class="{ 'bd-l': single, 'bd-b': !single }"
           style="position: relative;">
        <el-form class="h-100" :label-width="getLanguage() === 'zh_CN'? '100px' : '170px'"
                 v-if="currentProbe.id">
          <div class="uk-flex uk-flex-column h-100">
            <div class="pd-5 bd-b right-header">
              <el-form-item :label="$t('integration.installation_point_name')">
                <div class="w-100 uk-flex uk-flex-middle uk-flex-between">
                  <el-input v-if="mode === 'edit'" placeholder="" style="width: 250px;"
                            v-model="currentProbe.name" maxlength="20"></el-input>
                  <div v-else>{{ currentProbe.name }}</div>
                  <el-button type="primary" @click="applyProbe" v-if="mode === 'edit'" :disabled="isSwitching">
                    {{ $t('integration.application') }}
                  </el-button>
                  <el-button type="primary" @click="mode = 'edit'" v-else>{{ $t('integration.edit') }}</el-button>
                </div>
              </el-form-item>
            </div>

            <div class="pd-5 uk-flex-1" style="overflow:auto">

              <!-- 切换方式 -->
              <el-form-item :label="$t('device.switch_type')">
                <el-select v-if="mode === 'edit'" v-model="currentProbe.way" class="input-width">
                  <el-option :label="$t(item.title)" :value="parseInt(key)" :key="key"
                             v-for="(item, key) in switchType"></el-option>
                </el-select>
                <span v-else>
                                      {{ switchType[currentProbe.way] ? $t(switchType[currentProbe.way].title) : '-' }}
                                      </span>
                <el-popover
                  style="margin-left: 10px;"
                  placement="right-start"
                  width="360"
                  trigger="hover"
                >
                  <div>
                    <el-row>
                      <el-col :span="getLanguage() === 'zh_CN'? 5:8">
                        <span>{{ $t('device.intelligent_switch') }}:</span>
                      </el-col>
                      <el-col :span="16">
                        <span>{{ $t('device.intelligent_switch_desc') }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="getLanguage() === 'zh_CN'? 5:8">
                        <span>{{ $t('device.manual_switch') }}:</span>
                      </el-col>
                      <el-col :span="16">
                        <span>{{ $t('device.manual_switch_desc') }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="getLanguage() === 'zh_CN'? 5:8">
                        <span>{{ $t('device.direct_switch') }}:</span>
                      </el-col>
                      <el-col :span="16">
                        <span>{{ $t('device.direct_switch_desc') }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="getLanguage() === 'zh_CN'? 5:8">
                        <span>{{ $t('device.cancel_switch') }}:</span>
                      </el-col>
                      <el-col :span="16">
                        <span>{{ $t('device.cancel_switch_desc') }}</span>
                      </el-col>
                    </el-row>
                  </div>

                  <i class="el-icon-question cursor-pointer" slot="reference"></i>
                </el-popover>

              </el-form-item>


              <!-- 切换取消 -->
              <el-form-item v-if="currentProbe.way !== 3"
                            :label="$t('device.cancel_switch')">
                <el-input  v-if="mode === 'edit'" v-model.number="currentProbe.changeTime" style="width:100px;"
                           oninput="value=value.replace(/[^\d.]/g, '')"/>
                <el-select v-if="mode === 'edit'" v-model="currentProbe.changeTimeType"
                           style="margin-left: 10px; width: 140px"
                >
                  <el-option :label="$t(item.title)" :value="parseInt(key)" :key="key"
                             v-for="(item, key) in switchTime"></el-option>
                </el-select>
              </el-form-item>

              <AlarmStrategy ref="strategy" :mode="mode" :strategy="currentProbe" :useRef="true"
                             v-bind="$attrs" :scopeId="scopeId"></AlarmStrategy>

              <!-- 设备 -->
              <el-form-item
                v-if="isFirstAdd || currentDevice.id !== 0 || (!currentDevice.id && !changeDevice.id) ||
                                  (!isFirstAdd && currentProbe.way === 3)"
                :label="$t('public.device')">

                <div class="uk-flex">
                  <div v-if="!isFirstAdd" class="uk-flex uk-flex-middle">

                    <div class="ml-5  border uk-flex-inline uk-text-center "
                         v-if="currentDevice.id || changeDevice.id"
                         style="width: 200px;height: 30px;line-height:30px">
                      <div style="width: 30px;" class="bd-r">
                        <i class="cursor-pointer"
                           v-if="currentDevice.deviceType"
                           :class="equiIconConvert(currentDevice.deviceCatalog, currentDevice.deviceType).icon"
                           :title="$t(equiIconConvert(currentDevice.deviceCatalog, currentDevice.deviceType).title)"></i>
                        <i class="cursor-pointer"
                           v-else-if="changeDevice.deviceType"
                           :class="equiIconConvert(changeDevice.deviceCatalog, changeDevice.deviceType).icon"
                           :title="$t(equiIconConvert(changeDevice.deviceCatalog, changeDevice.deviceType).title)"></i>
                      </div>
                      <div class="uk-flex-1 bd-r bg-theme color-white">
                        {{ currentDevice.deviceCode ? currentDevice.deviceCode : changeDevice.deviceCode }}
                      </div>

                      <div style="width: 30px;" v-if="mode === 'edit'">
                        <i class="el-icon-circle-close color-red cursor-pointer"
                           @click="cancelRelate"></i>
                      </div>
                    </div>
                  </div>
                  <div v-else class="uk-flex uk-flex-middle">
                    <div class="ml-5  border uk-flex-inline uk-text-center "
                         style="width: 200px;height: 30px;line-height:30px"
                         v-if="changeDevice.id">
                      <div style="width: 30px;" class="bd-r">
                        <i class="cursor-pointer"
                           v-if="changeDevice.deviceType"
                           :class="equiIconConvert(changeDevice.deviceCatalog, changeDevice.deviceType).icon"
                           :title="$t(equiIconConvert(changeDevice.deviceCatalog, changeDevice.deviceType).title)"></i>
                      </div>
                      <div class="uk-flex-1 bd-r bg-theme color-white">
                        {{ changeDevice.deviceCode }}
                      </div>
                      <div style="width: 30px;" v-if="mode === 'edit'">
                        <i class="el-icon-circle-close color-red cursor-pointer"
                           @click="cancelChange"></i>
                      </div>
                    </div>
                  </div>

                  <!-- 只有传感器才能使用底座 -->
                  <!-- <div class="bd-l uk-flex uk-flex-center uk-flex-middle" style="width: 150px;"
                      v-if="currentDevice.deviceCatalog === 0">
                      <el-checkbox :disabled="mode === 'view'" :label="$t('integration.using_a_smart_base')"
                          v-model="currentProbe.usePlinth" :true-label="1" :false-label="0"
                          @change="useBase"></el-checkbox>
                  </div> -->

                  <div class="uk-flex-middle ml-5">
                    <i v-if="!isShowDeviceList" class="el-icon-printer icon cursor-pointer"
                       style="font-size: 18px;"
                       @click="showDeviceList">
                    </i>
                    <div v-else style="position: relative;">
                      <i  class="el-icon-back icon my-back-icon cursor-pointer"
                          @click="isShowDeviceList = false">
                      </i>
                      <!-- 设备列表 -->
                      <div v-if="isShowDeviceList"  class="device-div">
                        <div class="uk-flex ml-5 mt-5">
                          <el-select v-model="tableModel.code" @change="deviceTypeChange" style="width:150px;">
                            <el-option v-for="item in deviceTypeList" :key="item.code"
                                       :label="`${$t(deviceTypeListConvert[item.code])}`"
                                       :value="item.code"></el-option>
                          </el-select>
                          <el-input class="ml-5" v-model="tableModel.deviceCode" style="width:130px;"
                                    :placeholder="$t('integration.equipment_no')"></el-input>
                          <div class="ml-5">
                            <el-button type="primary" icon="el-icon-search" @click="seaechList"></el-button>
                            <el-button icon="el-icon-refresh" @click="resetCondition"></el-button>
                          </div>
                        </div>
                        <div class="device-div2" ref="deviceDiv"
                             v-infinite-scroll="loadmoreList"
                             infinite-scroll-disabled="scrollDisabled">
                          <el-table  :data="deviceList" :show-header="false" >
                            <el-table-column width="150px">
                              <template #default="{ row, $index }">
                                <div class="name-div">
                                  <div class="code-div" :class="{red: !row.deviceStatus}">{{ row.deviceCode }}</div>
                                  <el-row>
                                    <el-col :span="7">
                                      <el-checkbox v-model="checkbox[$index]"
                                                   @change="handleChangeDevice(row, $index)"></el-checkbox>
                                    </el-col>
                                    <el-col :span="17">{{ $t(equiStatusConvert(row.deviceStatus).title) }}</el-col>
                                  </el-row>
                                </div>
                              </template>
                            </el-table-column>
                            <el-table-column width="250px"  :label="$t('integration.monitoring_point')" prop="carrierName"
                                             show-overflow-tooltip>
                              <template #default="{row}">
                                <CardSwipper v-if="row.carrierName" :key="Math.random()" :list="row.carrierList">
                                  <template #title='{item}'>
                                    {{ item.scene }}
                                  </template>
                                  <template #default='{item}'>
                                    {{ item.carrierName }}
                                  </template>
                                </CardSwipper>
                                <div v-else class="no-tips">{{$t('public.no_monitoring_points')}}</div>
                              </template>
                            </el-table-column>
                          </el-table>

                          <p v-if="loading" style="text-align: center; padding: 10px;">{{ $t('text.Loading') }}</p>
                          <p v-if="noMore" style="text-align: center; padding: 10px;">{{ $t('public.no_more') }}</p>
                        </div>

                      </div>
                    </div>

                  </div>

                </div>

              </el-form-item>
              <!-- 底座：如果存在底座就自动显示 -->
              <el-form-item v-if="currentProbe.plinthId"
                            :label="$t('integration.base')">
                <div class="uk-flex uk-flex-middle">
                  <div class="ml-5  border uk-flex-inline uk-text-center"
                       style="width: 300px;height: 30px;line-height:30px">
                    <div style="width: 30px;" class="bd-r">
                      <i
                        class="iconfont icon-dianjidizuo color-theme"
                      ></i>
                    </div>
                    <div class="uk-flex-1 bd-r bg-theme color-white">
                      {{ currentProbe.plinthCode }}
                    </div>
                    <div style="width: 30px;">
                      <i class="el-icon-coordinate cursor-pointer"
                         :class="{'color-green': currentProbe.lockPlinth}"
                         @click="lockBase"></i>
                    </div>
                  </div>

                  <div v-if="currentProbe.lockPlinth" class="ml-10">
                    <el-checkbox :disabled="mode === 'view'" :label="$t('device.intelligent_switch')"
                                 v-model="currentProbe.plinthStrategy" :true-label="1"
                    ></el-checkbox>

                    <el-checkbox :disabled="mode === 'view'" :label="$t('device.direct_switch')"
                                 v-model="currentProbe.plinthStrategy" :true-label="2"
                    ></el-checkbox>
                  </div>
                </div>
              </el-form-item>
              <!-- 切换 -->
              <el-form-item
                v-if="(!isFirstAdd && currentProbe.way !== 3 && changeDevice.id) "
                :label="$t('device.switch')">
                <div class="uk-flex">
                  <div class="uk-flex uk-flex-middle">
                    <div class="ml-5  border uk-flex-inline uk-text-center "
                         style="width: 300px;height: 30px;line-height:30px">
                      <div style="width: 30px;" class="bd-r">
                        <i class="cursor-pointer"
                           v-if="changeDevice.deviceType"
                           :class="equiIconConvert(changeDevice.deviceCatalog, changeDevice.deviceType).icon"
                           :title="$t(equiIconConvert(changeDevice.deviceCatalog, changeDevice.deviceType).title)"></i>
                      </div>
                      <div class="uk-flex-1 bd-r bg-orange color-white">
                        {{ changeDevice.deviceCode }}
                      </div>
                      <div style="width: 30px;" v-if="mode === 'edit'">
                        <i class="el-icon-circle-close color-red cursor-pointer"
                           @click="cancelChange"></i>
                      </div>
                    </div>
                    <!-- <i v-if="isShowDeviceList" class="el-icon-back icon my-back-icon cursor-pointer"
                      @click="isShowDeviceList = false">
                      </i> -->
                  </div>
                </div>
              </el-form-item>


              <!-- 原来的底座选择 -->
              <!-- <el-form-item v-if="changeDevice.id && changeDevice.deviceCatalog === 0">
                <el-checkbox :disabled="mode === 'view'" :label="$t('integration.using_a_smart_base')"
                    v-model="currentProbe.usePlinth" :true-label="1" :false-label="0"
                    @change="useBase"></el-checkbox>
              </el-form-item>
              <el-form-item :label="$t('integration.base')" v-if="currentProbe.usePlinth">
                <div class="uk-flex">
                    <div class="uk-flex uk-flex-middle pl-5">
                        <template v-if="mode === 'edit'">
                            <el-select class="mr-5" v-el-select-loadmore="selectLoadMore" clearable
                                v-model="currentProbe.plinthId" filterable ref="currentBase"
                                :filter-method="baseFilter" :placeholder="$t('integration.please_enter_or_select_a_base_name')"
                                @clear="changeBaseType">
                                <el-option :label="item.deviceCode" :value="item.id"
                                    v-for="(item, index) in baseList.data" :key="index"></el-option>
                            </el-select>
                        </template>
                        <template v-else>
                            <i class="ml-5 mr-5" :class="baseType[currentProbe.plinthType].icon"
                                :title="$t(baseType[currentProbe.plinthType].title)"></i>
                            {{ currentProbe.plinthCode }}
                        </template>
                    </div>
                    <el-checkbox :disabled="mode === 'view'" :label="$t('device.intelligent_switch')"
                        v-model="currentProbe.plinthStrategy" :true-label="1"
                        ></el-checkbox>

                    <el-checkbox :disabled="mode === 'view'" :label="$t('device.direct_switch')"
                      v-model="currentProbe.plinthStrategy" :true-label="2"
                      ></el-checkbox>

                </div>
              </el-form-item> -->

              <!-- 剩余切换时间 -->
              <el-form-item
                v-if="currentProbe.way !== 3"
                :label="$t('device.remaining_switch_time')">
                <div :uk-countdown="currentProbe.remainingTime" ref="countdown"
                     v-if="isSwitching">
                  <span class="uk-countdown-number uk-countdown-days"></span>
                  <span class="uk-countdown-separator">{{ $t('task.detection_interval_day') }}</span>
                  <span class="uk-countdown-number uk-countdown-hours"></span>
                  <span class="uk-countdown-separator">{{ $t('task.detection_interval_hour') }}</span>
                  <span class="uk-countdown-number uk-countdown-minutes"></span>
                  <span class="uk-countdown-separator">{{ $t('task.detection_interval_minute') }}</span>
                </div>
                <i class="el-icon-refresh cursor-pointer ml-5"
                   :style="{color: isSwitching ? 'var(--primary-color)': '#aaa'}"
                   :title="$t('public.reflash')"
                   @click="resetRemainTime">
                </i>
              </el-form-item>
              <!-- 切换操作 -->
              <el-form-item :label="$t('device.switch_operation')">
                <!-- 开始切换 -->
                <el-button
                  v-if="currentProbe.way !== 3 && !isSwitching && !isFirstAdd && !isFinished"
                  type="primary"
                  @click="startSwitch(currentProbe.id)"
                >
                  {{ $t('device.start_switch') }}
                </el-button>
                <!-- 完成切换 -->
                <el-button
                  v-if="currentProbe.way === 2 && isSwitching"
                  type="primary" style="margin-left: 10px !important;"
                  @click="completeSwitch(currentProbe.id)">
                  {{ $t('device.complete_switch') }}
                </el-button>
                <!-- 终止切换 -->
                <el-button
                  v-if="isSwitching"
                  type="primary" style="margin-left: 10px !important;"
                  @click="stopSwitch(currentProbe.id)"
                >
                  {{ $t('device.stop_switch') }}
                </el-button>
                <!-- 历史 -->
                <el-button type="primary" style="margin-left: 10px !important;"
                           v-if="(typeof currentProbe.id !== 'string')"
                           @click="viewSwitchHistory">
                  {{ $t('device.history') }}
                </el-button>
                <!-- 通知 -->
                <el-button type="primary" style="margin-left: 10px !important;"
                           @click="isShowNoticeObject = true"
                >{{ $t('device.notice') }}
                </el-button>
              </el-form-item>
            </div>

          </div>
          <!-- 设备列表遮罩层 -->
          <div v-if="isShowDeviceList" class="my-mask" @click="closeMask"></div>
        </el-form>
        <div v-else class="h-100">
          <span class="empty text-middle">{{ $t('integration.please_add_a_probe_first') }}</span>
        </div>
      </div>
    </div>

    <!-- <template #footer>
        <el-button type="primary" @click="save">{{ $t('integration.preservation') }}</el-button>
    </template> -->


    <!-- 切换历史模态框 -->
    <SwitchHistory
      :isShow="isShowSwitchHistory"
      :deviceId="currentProbe.id"
      @close="isShowSwitchHistory = false"
    >
    </SwitchHistory>

    <!-- 通知对象模态框 -->
    <NoticeDialog
      :isShow="isShowNoticeObject"
      :carrierDeviceId='currentProbe.id'
      :type="$route.query.type"
      :isFirstAdd="isFirstAdd"
      @close="isShowNoticeObject = false"
      @selectNotice="handleSelectNotice"
    ></NoticeDialog>

  </modal>
</template>

<script>
import AlarmStrategy from './AlarmStrategy.vue'
import { sampleSrategy, relateWay, equiIconConvert, equiType, equiStatusConvert, baseType, baseStrategy, switchType, switchTime,deviceTypeListConvert } from '@/utils/convert'
import { getDeviceType } from '@/api/modules/public'

import { carrierRelectList, getDevicePage, addRelation, delRelation, updateRelation, probeDetail, getBasePageList,
  saveCarrierDevice, getCarrierDevicePage, carrierChangeStart, carrierChangeStop, carrierNoticeSave, getCarrierInfo,
  carrierChangeComplete } from '@/api/modules/carrier'
import search from '@/utils/search'
import bus from '@/utils/bus'

import { _debounce } from '@/utils/common'

import CardSwipper from '@/components/CardSwipper/CardSwipper.vue'

import SwitchHistory from './SwitchHistory.vue'
import NoticeDialog from '@/pages/business/components/dialog/NoticeDialog.vue'
import { getLanguage } from '@/lang';

export default {
  props: {
    show: {
      type: Boolean
    },
    scopeId: {},
    relationList: {},
    carrierId: {},
    carrierInfo: {}
  },
  watch: {
    show () {
      if (this.show) {
        this.getDeviceType().then(() => {
          this.getListFn()
          // 当前未选中
          if (this.probeList.length && !this.currentProbe.id) {
            this.changeProbe(this.probeList[0])
          }
        })
      } else {
        // 关闭之后清除为创建的列表项
        const last = this.probeList[this.probeList.length - 1]
        // 最后一项未保存则清除
        if (last && typeof last.id === 'string') {
          this.probeList.pop()
          this.currentProbe = {}
        }
        this.isShowDeviceList = false
      }
    },
    scopeId () {
      this.tableModel.sceneId = this.scopeId
      this.tableModel.structureId = this.carrierInfo.structureId

      this.baseListModel.sceneId = this.scopeId
      this.baseListModel.structureId = this.carrierInfo.structureId

      // this.getProbeList();
      this.$emit('getList')
    },
    relationList (newval) {
      this.probeList = [...newval].sort((a, b) => {
        return a.createTime - b.createTime
      })
      this.rawProbeList = this.probeList
      if(!this.probeList.length){
        this.currentProbe = {};
      }
    }
  },
  components: {
    AlarmStrategy,
    CardSwipper,
    SwitchHistory,
    NoticeDialog
  },
  computed: {
    visible: {
      set (newval) {
        this.$emit('update:show', newval)
      },
      get () {
        return this.show
      }
    },
    equiType: () => equiType,
    equiIconConvert: () => equiIconConvert,
    equiStatusConvert: () => equiStatusConvert,
    baseType: () => baseType,
    baseStrategy: () => baseStrategy,
    scrollDisabled(){
      return this.loading || this.noMore
    },
    noMore() {
      return this.deviceList.length >= this.total
    },
    // 切换状态不可编辑
    isSwitching(){
      return this.currentProbe.status === 1
    },
    // 区别初次新增安装点还是编辑
    isFirstAdd(){
      return typeof this.currentProbe.id === 'string'
    },
    // 是否是切换完成状态
    isFinished(){
      return this.currentProbe.status === 2
    },
    deviceTypeListConvert: () => deviceTypeListConvert,
  },
  data () {
    return {
      deviceListParams: {
        // 设备类型
        type: 0,
        // 设备编号
        no: ''
      },
      // 底座设备列表  根据温度计底座或者温湿度计底座进行区分
      baseList: {
        data: [],
        total: 0,
        disableLoad: false
      },
      model: {
        strategy: 0,
        way: 2,
        searchName: '',
        usePlinth: 0,
        plinthId: null
      },
      tableModel: {
        iDisplayStart: 0,
        iDisplayLength: 10,
        sceneId: 0,
        structureId: 0,
        deviceCatalog: 0,
        deviceCode: '',
        code: ''
      },
      baseListModel: {
        iDisplayStart: 0,
        iDisplayLength: 10,
        sceneId: 0,
        structureId: 0,
        deviceCode: '',
        // deviceType: 1
      },
      sampleSrategy,
      relateWay,

      // 设备类型
      deviceType: null,
      probeList: [],
      rawProbeList: [],
      currentProbe: {

      },
      // 下方设备列表
      deviceList: [],
      total: 0,
      deviceTypeList: [],
      checkbox: [],
      currentDevice: {},
      loading: false,
      // 是否只显示单个探头的详情
      single: false,
      title: $t('integration.installation_point'),
      mode: 'edit',
      carrierType: 0,

      switchType,
      switchTime,
      switching: false, // 是否正在切换的flag
      isShowSwitchHistory: false,
      isShowDeviceList: false,
      isShowNoticeObject: false,

      noticeClxList: [], // 安装点通知对象列表
      changeDevice: {}, // 要切换的新设备

      remainingTime: null , // 切换剩余时间
      resetRemainingTime: 0, // 保留剩余时间的初始值

      resultId: null, // 安装点ID

      getLanguage
    }
  },
  methods: {
    // 由于可能是一个设备对应多个监测点 需要对监测点进行预处理
    carrierPreHandle (row) {
      if (!row.carrierId) { return [] }

      const info = []
      const carrierIds = row.carrierId.split(',')
      const carrierNames = row.carrierName.split(',')
      const scenes = row.structureName.split(',')
      carrierIds.forEach((id, index) => {
        info.push({
          id,
          carrierName: carrierNames[index],
          scene: scenes[index]
        })
      })
      return info
    },
    // 获取左侧关联映射列表
    getProbeList () {
      const { type, id } = this.$route.query
      carrierRelectList(type, id).then(res => {
        this.probeList = res.result
        if (res.result) {
          if (res.result.length) {
            this.currentProbe = JSON.parse(JSON.stringify(res.result[0]))
            console.log('this.currentProbe=', this.currentProbe)
            const first = res.result[0]
            console.log(first)

            this.currentDevice = {
              id: first.deviceId,
              deviceCatalog: first.deviceCatalog,
              deviceType: first.deviceType,
              deviceCode: first.deviceCode
            }
          }
        }
      })
    },
    changeProbe (probe) {
      console.log('probe=====', probe)
      probe.usePlinth = probe.plinthId ? 1 : 0
      if (probe.id === this.currentProbe.id) return this.currentProbe = probe
      if (this.isFirstAdd) {
        return this.$message.warning($t('integration.currently_associating_devices_c__please_complete_the_addition_before_switching'))
      }
      this.currentProbe = JSON.parse(JSON.stringify(probe))

      if (this.currentProbe.usePlinth) {
        this.useBase(1)
      }
      this.tableModel.deviceCatalog = probe.deviceCatalog
      this.tableModel.deviceType = probe.deviceType
      const deviceType = this.deviceTypeList.find(item => (item.deviceCatalog === probe.deviceCatalog && item.id === probe.deviceType))

      if (deviceType) { this.tableModel.code = deviceType.code }
      this.getListFn()

      this.currentDevice = {
        id: probe.deviceId,
        deviceCatalog: probe.deviceCatalog,
        deviceType: probe.deviceType,
        deviceCode: probe.deviceCode
      }
      // 需要选中一下当前的设备
      this.selectCurrentDevice()

      this.changeDevice = {
        id: probe.changeDeviceId,
        deviceCatalog: probe.changeDeviceCatalog,
        deviceType: probe.changeDeviceType,
        deviceCode: probe.changeDeviceCode
      }
      this.isShowDeviceList = false

      console.log('currentProbe=====', this.currentProbe)
      console.log('currentDevice=', this.currentDevice)
      console.log('changeDevice=', this.changeDevice)

      // 重置设备列表的搜索条件
      this.resetCondition()

    },
    // 设备列表滚动加载下一页
    loadmoreList(){
      this.tableModel.iDisplayStart += this.tableModel.iDisplayLength
      this.getListFn(true)
    },
    // 获取table列表
    getListFn (next = false) {
      console.log('getListFn----------------------------')
      this.loading = true

      getDevicePage(this.carrierInfo.carrierType, this.tableModel)
        .then(res => {
          if (!res.result) {
            return
          }
          const { pageInfo, result } = res.result
          this.total = pageInfo ? pageInfo.total : 0
          // 如果返回结果为空，说明没有更多数据了，将 total 设为当前列表长度以停止加载
          if (!result || result.length === 0) {
            this.total = this.deviceList.length
            return
          }
          let curDeviceList = next ? this.deviceList : []
          let list = result.map(row => {
            row.carrierList = this.carrierPreHandle(row)
            return row
          })
          this.deviceList = curDeviceList.concat(list)
          this.selectCurrentDevice()
        })
        .finally(() => {
          if(this.isShowDeviceList){
            this.$refs.deviceDiv.scrollTop = this.$refs.deviceDiv.scrollTop - 5
          }
          this.loading = false
        })
    },
    // 在table选择当前currentDeviceId对应的设备
    selectCurrentDevice () {
      this.checkbox = this.deviceList.map(() => false)
      if (this.currentDevice.id) {
        const index = this.deviceList.findIndex(item => item.id === this.currentDevice.id)
        if (index !== -1) {
          this.checkbox[index] = true
        }
      }
    },
    getDeviceType () {
      return new Promise(resolve => {
        getDeviceType().then(({ result }) => {
          // 先前端过滤调底座
          result = result.filter(item => {
            if (item.code === 'pt_1' || item.code === 'pt_2') { return false }
            return true
          })
          this.deviceTypeList = result
          if (result.length) {
            this.tableModel.code = result[0].code
            this.tableModel.deviceType = result[0].id
            this.tableModel.deviceCatalog = parseInt(result[0].deviceCatalog) || 0
          }
          console.log(' this.tableModel.deviceType=',  this.tableModel.deviceType)
          resolve()
        })
      })
    },
    handleChangeDevice (device, index) {
      console.log('device=====', device)
      // this.currentDevice = { ...device }
      this.changeDevice = { ...device }
      // 当是直接切换时，选择的切换设备渲染到设备中，所以currentDevice也赋值changeDevice
      if(this.currentProbe.way === 3){
        this.currentDevice = { ...device }
      }
      // 只有传感器才能使用底座
      if (this.currentDevice.deviceCatalog !== 0) {
        this.currentProbe.usePlinth = 0
        // 参数清理
        this.currentProbe.strategy = 0
      }
      this.checkbox = this.checkbox.map(() => false)
      this.checkbox[index] = true
      this.currentProbe.deviceCatalog = this.changeDevice.deviceCatalog
      this.currentProbe.deviceType = this.changeDevice.deviceType
      this.currentProbe.deviceId = this.changeDevice.id
      // this.$set(this.currentProbe, 'deviceCatalog', this.currentDevice.deviceCatalog);
      // this.$set(this.currentProbe, 'device_type', this.currentDevice.deviceType);
      // this.$set(this.currentProbe, 'deviceId', this.currentDevice.id);
      console.log('this.currentProbe=',this.currentProbe)

      // 选择了另一个设备，跟随的底座也要变
      this.$set(this.currentProbe, 'plinthId', this.changeDevice.plinthDevId)
      this.$set(this.currentProbe, 'plinthCode', this.changeDevice.plinthDevCode)
      this.$set(this.currentProbe, 'plinthStrategy', 1)
      this.$set(this.currentProbe, 'lockPlinth', 0)

      this.$forceUpdate()
    },
    deviceTypeChange (code) {
      const device = this.deviceTypeList.find(item => item.code === code)

      if (device) {
        this.tableModel.deviceType = device.id
        this.tableModel.deviceCatalog = parseInt(device.deviceCatalog) || 0
        if (!this.currentProbe.deviceId) {
          this.$set(this.currentProbe, 'deviceCatalog', device.deviceCatalog)
          this.$set(this.currentProbe, 'deviceType', device.deviceType)
        }
        // this.getListFn()
        this.seaechList()
      }
    },
    resetCondition () {
      this.tableModel.deviceCode = ''
      this.seaechList()
    },
    seaechList(){
      this.tableModel.iDisplayStart = 0
      this.deviceList = []
      this.getListFn()
    },
    // 新增本地的Probe  不需要提交到服务器
    addProbe () {
      if (this.isFirstAdd) {
        this.$message.warning($t('integration.currently_adding_c__please_save_or_delete_and_try_again'))
        return
      }

      // 本地的探头数据ID是string类型的  用这个区分开来
      this.probeList.push({
        id: new Date().getTime().toString(),
        strategy: 1,
        // 默认值：直接切换
        way: 3,
        deviceCatalog: 0,
        name: $t('integration.new_name'),
        changeTimeType: 1
      })
      this.currentProbe = this.probeList[this.probeList.length - 1]
      this.currentDevice = {}
      this.checkbox = this.checkbox.map(() => false)
      this.changeDevice = {}
      this.isShowDeviceList = false
      console.log('add----------currentProbe=', this.currentProbe)

      // 新增的时候重新获取设备列表默认选择第一项
      const firstDevice = this.deviceTypeList[0]
      if (firstDevice) {
        this.tableModel.code = firstDevice.code
        this.tableModel.deviceType = firstDevice.id
        this.tableModel.deviceCatalog = parseInt(firstDevice.deviceCatalog) || 0
        this.seaechList()
      }

    },
    // 应用上方探头信息
    async applyProbe () {

      if (!this.currentProbe.name) return this.$message.warning($t('integration.please_enter_the_association_name'))
      // if (!this.currentDevice.id) return this.$message.warning($t('integration.please_select_the_device_to_be_associated'));
      // const data = await this.$refs.strategy.getData()

      console.log('this.currentProbe===', this.currentProbe)
      let flag = false

      // 判断要切换的设备是否绑定安装点，给提示
      if(this.changeDevice.carrierName){
        await this.$confirm(this.$t('device.switch_carrierName_tips'), this.$t('public.prompt'), {
          confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
          cancelButtonText: this.$t('public.btn_no'), // 取消按钮的文案
          type: 'warning'
        })
          .then(() => {
            flag = true
          })
          .catch(() => {
            flag = false
          })
      }else{
        flag = true
      }

      if(flag){
        // 如果当前切换方式为智能切换/人工切换，弹出提示框

        // 新增的时候只是保存配置？不调开始切换？
        // if (this.isFirstAdd) {
        // 只保存设置
        // this.saveCarrierSetting(false)
        // }else{
        if(this.currentProbe.way !== 3 && this.changeDevice.id){
          this.$confirm(this.$t('device.switch_now'), this.$t('public.prompt'), {
            confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
            cancelButtonText: this.$t('public.btn_no'), // 取消按钮的文案
            type: 'info'
          })
            .then(() => {
              // 保存设置并开始设备切换
              this.saveCarrierSetting(true)

            })
            .catch(() => {
              // 只保存设置
              this.saveCarrierSetting(false)
            })
        }else{
          this.saveCarrierSetting(false)
          // this.saveCarrierSetting(true)
        }
        // }

      }



      // 提示重复
      // if (data.way === 2) {
      //     if (this.currentDevice.carrierName) {
      //         return this.$message.warning($t('integration.the_device_is_already_bound_to_a_monitoring_point'));
      //     }
      // }


      // this.getProbeList();
    },
    // 单独提取保存设备切换配置功能
    // startFlag:点击应用是是否立即切换标志
    async saveCarrierSetting(startFlag){
      const data = await this.$refs.strategy.getData()

      const { deviceCatalog, id, deviceType, deviceCode } = this.currentDevice

      console.log('tableModel=', this.tableModel)
      console.log('currentDevice=', this.currentDevice)
      console.log('currentProbe=', this.currentProbe)


      const params = {
        ...data,
        name: this.currentProbe.name,
        way: this.currentProbe.way,
        carrierId: this.$route.query.id || this.carrierId,
        // 新增时，原来的设备为空
        // 原来的设备
        // deviceCatalog: deviceCatalog || this.tableModel.deviceCatalog,
        // device_type: deviceType || this.tableModel.deviceType,
        // deviceId: this.currentProbe.way ===3 ? null : id,
        // deviceCatalog: this.currentProbe.way ===3 ? null : deviceCatalog,
        // device_type: this.currentProbe.way ===3 ? null : deviceType,

        deviceId: id,
        deviceCatalog: deviceCatalog,
        deviceType: deviceType,
        // 原来的设备

        // 要切换的设备
        changeDeviceCatalog: this.changeDevice.deviceCatalog,
        changeDeviceId: this.changeDevice.id,
        changeDeviceType: this.changeDevice.deviceType,
        changeDeviceCode: this.changeDevice.deviceCode,
        // 要切换的设备

        // 使用底座时参数
        usePlinth: this.currentProbe.usePlinth,
        plinthId: this.currentProbe.plinthId,
        plinthCode: this.currentProbe.plinthCode,
        plinthStrategy: this.currentProbe.plinthStrategy,
        // 是否锁定底座
        lockPlinth: this.currentProbe.lockPlinth,


        // status: 0,
        changeTime: this.currentProbe.changeTime,
        changeTimeType: this.currentProbe.changeTimeType,

        // 增加noticeClxList参数
        noticeClxList: this.noticeClxList
      }

      // 当是直接切换的编辑时，不需要change_device
      // 根据changeDeviceId判断直接切换是否选了新设备
      if(!this.isFirstAdd && this.currentProbe.way ===3 && !params.changeDeviceId){
        delete params.changeDeviceCatalog
        delete params.changeDeviceId
        delete params.changeDeviceType
        delete params.changeDeviceCode
      }

      // 勾选了使用底座就必须选择智能底座
      // if (this.currentProbe.usePlinth) {
      //   if (!params.plinthId) { return this.$message.warning('请选择智能底座') }
      // }

      console.log(params)

      let result = null

      // 自己创建的ID即是string类型
      // if (typeof this.currentProbe.id === 'string') {
      if (this.isFirstAdd) {
        delete params.id
        // result = await addRelation(this.$route.query.type, params)
        result = await saveCarrierDevice(this.$route.query.type, params)
      } else {
        // 说明是编辑
        // result = await updateRelation(this.$route.query.type || this.carrierType, params)
        result = await saveCarrierDevice(this.$route.query.type || this.carrierType, params)
      }
      console.log('result->',result);

      if (result.result > 0) {
        // 刷新设备列表
        // this.getListFn()

        // result.result返回的是安装点的id,保存配置成功后，后面的“开始/终止切换”需要用到这个id
        if(startFlag){
          this.startSwitch(result.result)
        }
        this.resultId = result.result



        if (this.isFirstAdd) {
          this.$message.success($t('integration.successfully_added_installation_point'))
          this.$emit('getList', () => {
            this.currentProbe = {}
            this.changeProbe(this.probeList[this.probeList.length - 1])
          })
        } else {
          this.$message.success($t('integration.edit_succeeded'))
          this.$emit('getList')
          if (this.single) {
            this.getProbeDetail(this.currentProbe.code, this.carrierType)
            this.mode = 'view'
          }
        }
      } else {
        if (data.way === 2) {
          switch (result.result) {
            case -1:
              this.$message.error('保存失败')
              break
            case -2:
              this.$message.warning('设备已关联资产')
              break
            case -3:
              this.$message.warning('设备已关联在当前资产')
              break
          }
        }
      }
    },
    // 删除关联  删除探头
    deleteProbe (probe, index) {
      if (this.isFirstAdd && this.currentProbe.id !== probe.id) { return this.$message.warning('请保存或删除本项之后再进行操作') }

      this.$confirm($t('integration.are_you_sure_you_want_to_delete_this_item')).then(res => {
        if (typeof probe.id === 'string') {
          this.probeList.splice(index, 1)
          // 删除的是自己
          if (probe.id === this.currentProbe.id) {
            // 重置当前probe
            console.log('this.probeList----', this.probeList)
            if (this.probeList.length) {
              this.currentProbe = {}
              this.changeProbe(this.probeList[0])
            } else {
              this.currentProbe = {}
            }
          }
        } else {
          delRelation(this.$route.query.type || this.carrierType, probe.id).then(res => {
            this.$message.success($t('integration.successfully_deleted'))
            // this.getProbeList();
            this.$emit('getList')
            if (probe.id === this.currentProbe.id) {
              // 重置当前probe
              console.log('this.probeList----', this.probeList)
              if (this.probeList.length) {
                this.currentProbe = {}
                this.changeProbe(this.probeList[0])
              } else {
                this.currentProbe = {}
              }
            }
          })
        }
      })
    },
    searchNameChange () {
      if (this.model.searchName === '') return (this.probeList = this.rawProbeList)
      this.probeList = search(this.model.searchName, 'name', this.rawProbeList)
    },
    // 设备身上的取消关联设备
    cancelRelate () {
      this.$confirm($t('integration.are_you_sure_you_want_to_dissociate_this_device')).then(res => {
        this.currentProbe.deviceId = undefined

        this.$set(this.currentProbe, 'deviceType', this.tableModel.deviceType)
        this.$set(this.currentProbe, 'deviceCatalog', this.tableModel.deviceCatalog)

        this.currentDevice = {}
        this.checkbox = this.checkbox.map(() => false)
      })
    },
    // 取消所选择的切换设备
    cancelChange(){
      this.$confirm($t('integration.are_you_sure_you_want_to_dissociate_this_device')).then(res => {
        this.currentProbe.deviceId = undefined

        this.$set(this.currentProbe, 'deviceType', this.tableModel.deviceType)
        this.$set(this.currentProbe, 'deviceCatalog', this.tableModel.deviceCatalog)

        // this.currentDevice = {}
        this.changeDevice = {}
        this.checkbox = this.checkbox.map(() => false)
      })
    },
    // 获取底座分页列表
    getBaseList (code) {
      this.baseListModel.deviceCode = code
      if (this.baseList.disableLoad) {
        return
      }
      // getBasePageList({ ...this.baseListModel, deviceType: this.currentProbe.plinthType }, this.carrierInfo.carrierType).then(({ result }) => {
      getBasePageList({ ...this.baseListModel }, this.carrierInfo.carrierType).then(({ result }) => {
        const { pageInfo, result: data } = result
        const { iDisplayStart } = this.baseListModel

        if (iDisplayStart === 0) {
          this.baseList.data = data
        } else {
          this.baseList.data = this.baseList.data.concat(data)
        }
        if (pageInfo.total <= this.baseList.data.length) {
          this.baseList.disableLoad = true
        }
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.currentBase.$data.selectedLabel = this.currentProbe.plinthCode
          }, 500)
        })
      })
    },
    // 使用底座与不使用底座之间切换触发
    useBase (data) {
      // 点击使用智能底座后 去获取当前选项中的智能底座列表
      if (data) {
        this.currentProbe.strategy = 1
        this.$set(this.currentProbe, 'plinthType', 1)
        if (!this.currentProbe.plinthId) {
          this.$set(this.currentProbe, 'plinthId', null)
        }
        this.getBaseList()
      } else {
        this.currentProbe.plinthId = null
        this.currentProbe.strategy = 0
        this.currentProbe.usePlinth = 0
      }
    },
    // 底座搜索方法
    baseFilter: _debounce(function (text) {
      this.resetBaseSearchParams()
      this.getBaseList(text)
    }, 500),
    changeBaseType () {
      this.currentProbe.plinthId = null
      this.baseListModel.iDisplayStart = 0
      this.resetBaseSearchParams()
      this.getBaseList()
    },
    // 重置底座的搜索参数
    resetBaseSearchParams () {
      this.iDisplayStart = 0
      this.baseList.disableLoad = false
    },
    selectLoadMore () {
      this.baseListModel.iDisplayStart += this.baseListModel.iDisplayLength
      this.getBaseList()
    },
    getProbeDetail (probeCode, carrierType) {
      // 改变currentProbe
      probeDetail(null, probeCode, carrierType).then(({ result }) => {
        if (result) {
          this.changeProbe(result)
          this.visible = true
        } else {
          this.$message.error($t('integration.the_installation_point_does_not_exist'))
          this.visible = false
        }
      })
    },
    // 开始切换
    startSwitch(id){
      carrierChangeStart(id).then(res => {
        if (res.state.code === 200) {
          this.$message.success($t('integration.success'))
          // 开始切换成功后获取安装点信息计算剩余时间
          getCarrierInfo(this.$route.query.type, id).then(res => {
            if (res.state.code === 200) {
              let  addTime = this.currentProbe.changeTime
              console.log('---addTime-----',addTime)
              if(this.currentProbe.changeTimeType === 1){ // 单位：分
                addTime = addTime * 60 * 1000
              }else if (this.currentProbe.changeTimeType === 2){ // 单位：时
                addTime = addTime * 60 * 60 * 1000
              }else{
                addTime = addTime * 24 * 60 * 60 * 1000
              }

              // this.remainingTime = res.result.start_time + addTime
              this.remainingTime = 'date:' +  this.$timetransition(res.result.startTime + addTime)
              this.currentProbe.remainingTime = 'date:' +  this.$timetransition(res.result.startTime + addTime)

              this.resetRemainingTime = this.remainingTime

              // 设置状态
              // this.currentProbe.status = res.result.status
              this.$set(this.currentProbe, 'status', res.result.status)
              this.$emit('getList')

            }
          })
        }
      })
    },
    // 查看切换历史
    viewSwitchHistory(){
      console.log('currentDevice=========', this.currentDevice)
      this.isShowSwitchHistory= true
    },
    // 点击设备图标显示设备筛选框
    showDeviceList(){
      this.isShowDeviceList = true
    },
    // 终止切换
    stopSwitch(id){
      carrierChangeStop(id).then(res => {
        if (res.state.code === 200) {
          this.$message.success($t('integration.success'))
          getCarrierInfo(this.$route.query.type, id).then(res => {
            if (res.state.code === 200) {
              // 设置状态
              // this.currentProbe.status = res.result.status
              this.$set(this.currentProbe, 'status', res.result.status)
              this.$emit('getList')

            }
          })
          this.currentProbe.remainingTime = 0
        }
      })
    },
    handleSelectNotice(data){
      // const { type, id } = this.$route.query
      this.noticeClxList = data
    },
    // 重置剩余时间为初始值
    resetRemainTime(){
      // 以当前时间重新计算？
      let  addTime = this.currentProbe.changeTime
      console.log('---addTime-----',addTime)
      if(this.currentProbe.changeTimeType === 1){ // 单位：分
        addTime = addTime * 60 * 1000
      }else if (this.currentProbe.changeTimeType === 2){ // 单位：时
        addTime = addTime * 60 * 60 * 1000
      }else{
        addTime = addTime * 24 * 60 * 60 * 1000
      }

      this.remainingTime = 'date:' +  this.$timetransition(Date.now() + addTime)
      this.currentProbe.remainingTime = 'date:' +  this.$timetransition(Date.now() + addTime)

      // this.resetRemainingTime = this.remainingTime
      // this.currentProbe.remainingTime = this.resetRemainingTime
      this.$message.success($t('integration.success'))
    },
    // 完成切换
    completeSwitch(id){
      carrierChangeComplete(id).then(res => {
        if (res.state.code === 200) {
          this.$message.success($t('integration.success'))
          getCarrierInfo(this.$route.query.type, id).then(res => {
            if (res.state.code === 200) {
              // 设置状态
              // this.currentProbe.status = res.result.status
              this.$set(this.currentProbe, 'status', res.result.status)
              this.currentProbe = JSON.parse(JSON.stringify( res.result))
              this.currentDevice = {
                id: res.result.deviceId,
                deviceCatalog: res.result.deviceCatalog,
                deviceType: res.result.deviceType,
                deviceCode: res.result.deviceCode
              }

              this.changeDevice = {
                id: res.result.changeDeviceId,
                deviceCatalog: res.result.changeDeviceCatalog,
                deviceType: res.result.changeDeviceType,
                deviceCode: res.result.changeDeviceCode
              }
              this.$emit('getList')
            }
          })
          this.currentProbe.remainingTime = 0
        }
      })
    },
    // 关闭遮罩层
    closeMask(){
      this.isShowDeviceList = false
      // this.resetCondition()
    },
    // 点击锁定底座
    lockBase(){
      let lockPlinth = this.currentProbe.lockPlinth
      if (!lockPlinth) {
        // this.currentProbe.strategy = 1
        // this.$set(this.currentProbe, 'plinthType', 1)
        // if(this.isFirstAdd){
        //   this.$set(this.currentProbe, 'plinthId', this.changeDevice.plinthDevId)
        //   this.$set(this.currentProbe, 'plinthCode', this.changeDevice.plinthDevCode)
        //   this.$set(this.currentProbe, 'plinthStrategy', 1)

        // }

        this.$set(this.currentProbe, 'lockPlinth', 1)

      } else {
        // this.currentProbe.plinthId = null
        // this.currentProbe.strategy = 0
        // this.currentProbe.plinthCode = null
        this.$set(this.currentProbe, 'lockPlinth', 0)

      }
    },
  },
  mounted () {
    // 可以通过bus唤出
    bus.$on('probeDetailParam', _debounce(({ probeCode, carrierType }) => {
      this.mode = 'view'
      this.single = true
      this.title = $t('integration.installation_point_details')
      this.carrierType = carrierType
      this.getProbeDetail(probeCode, carrierType)
    }), 500)
  },
  beforeDestroy () {
    bus.$off('probeDetailParam')
  }
}
</script>

<style scoped lang="scss">
.reflect-box {
  width: 250px;

  .reflect-item {
    border-radius: 3%;
    line-height: 30px;
    margin: 5px;
  }

  .active {
    background-color: $theme-color;
    color: white;
  }
}

.right-header {
  ::v-deep .el-form-item {
    margin-bottom: 0 !important;
  }
}

.bottom-area {
  height: 40px;
  line-height: 40px;
}

.el-button {
  margin: 0;
}

.wrpper-h {
  height: 600px;
}
.my-back-icon {
  color: #FFFFFF;
  background-color: var(--primary-color);
  padding: 3px;
  border-radius: 50%;
  font-size: 16px;
}
.device-div {
  background-color: #FFFFFF;
  z-index: 999;
  position: absolute;
  left: 30px;
  top: -10px;
  width: 450px;
  border: 1px solid #AAAAAA;
  border-radius: 5px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, .3);
  .device-div2{
    width: 450px;
    height: 170px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .no-tips {
    width: 100%;
    height: 50px;
    border: 1px solid #AAAAAA;
    text-align: center;
    align-content: center;
  }
  .name-div {
    border: 1px solid #AAAAAA;
  }
  .code-div {
    border-bottom: 1px solid #AAAAAA;
    text-align: center;
    &.red {
      color: red;
    }
  }
  ::v-deep .el-col {
    text-align: center;
    border-right: 1px solid #AAAAAA;
    &:last-child {
      border-right: none;
    }
  }
  ::v-deep .el-table__cell {
    padding: 8px 2px !important;
  }
}

::v-deep .uk-countdown {
  display: inline-block;
}
.uk-countdown-separator {
  font-size: 14px !important;
}
.uk-countdown-number {
  font-size: 14px !important;
}

.my-mask{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

</style>
